var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CodeSnippet"},[_c('code',[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){$event.preventDefault();return _vm.copyText.apply(null, arguments)}}},[_c('v-icon',[_vm._v("\n      fal fa-fw fa-copy\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }